import { client } from "./client.ts";
import { BASE_URL } from "./client.ts";

const base_url = "/inspect-status";
const stream_url = "/stream";

// 검사현황 유닛 단위 조회
export const getInspStatusUnit = async (params) => {
  try {
    const response = await client.get(`${base_url}/insp-status-unit`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getUnitInfo = async (ids) => {
  try {
    const response = await client.post(`${base_url}/unit-info`, { ids });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 클라이언트 IP 조회
export const getClientIp = async () => {
  try {
    const response = await client.get(`${base_url}/client-ip`);
    // console.log("response", response.data);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// IP 별 정제된 데이터 조회
export const getDataByDate = async ({
  client_ip,
  start_date,
  end_date,
  material_name,
  filter,
  page,
  pageSize,
}) => {
  try {
    const response = await client.get(`${base_url}/data-by-date/${client_ip}`, {
      params: { start_date, end_date, material_name, filter, page, pageSize },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// IP 별 일자별 AVI 과검률 데이터 조회
export const getAviOIData = async ({
  client_ip,
  start_date,
  end_date,
  material_name,
  referenceAI,
  referenceAVI,
  signal,
  site,
}) => {
  try {
    console.log("site", site);
    const response = await client.get(`${base_url}/avi-oi-data/${client_ip}`, {
      params: {
        start_date,
        end_date,
        material_name,
        referenceAI,
        referenceAVI,
        signal,
        site,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// IP 별 일자별 AVI 과검률 데이터 조회 SSE
export const getAviOIDataStream = ({
  client_ip,
  start_date,
  end_date,
  material_name,
  referenceAI,
  referenceAVI,
  signal,
  onMessage,
  onError,
  onComplete,
}) => {
  // const eventSource = new EventSource(
  //   `${baseURL}/avi-oi-data-stream/${client_ip}?${new URLSearchParams({
  //     start_date,
  //     end_date,
  //     material_name,
  //     referenceAI,
  //     referenceAVI,
  //     signal,
  //   }).toString()}`
  // );
  // eventSource.onmessage = (event) => {
  //   try {
  //     const data = JSON.parse(event.data);
  //     if (data.error) {
  //       onError?.(data.error);
  //       eventSource.close();
  //       return;
  //     }
  //     onMessage?.(data);
  //     if (data.isComplete) {
  //       onComplete?.();
  //       eventSource.close();
  //     }
  //   } catch (error) {
  //     onError?.(error);
  //     eventSource.close();
  //   }
  // };
  // eventSource.onerror = (error) => {
  //   onError?.(error);
  //   eventSource.close();
  // };
  // return () => {
  //   eventSource.close();
  // };
};

// Lot 목록 조회
export const getLotList = async () => {
  try {
    const response = await client.get(`${base_url}/insp-status-lot-list`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// 최신 데이터 날짜 조회
export const getLatestData = async () => {
  try {
    const response = await client.get(`${base_url}/latest-data`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getDieCount = async (params) => {
  try {
    const response = await client.get(`${base_url}/die-count`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getUnitCount = async (params) => {
  try {
    const response = await client.get(`${base_url}/unit-count`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getGroupCount = async (params) => {
  try {
    const response = await client.get(`${base_url}/group-count`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getGroupCountStream = ({
  params,
  onMessage,
  onError,
  onComplete,
}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value != null)
  );

  const eventSource = new EventSource(
    `${BASE_URL}${base_url}/group-count-stream?${new URLSearchParams(
      cleanParams
    ).toString()}`
  );

  eventSource.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);

      if (data.error) {
        onError?.(data.error);
        eventSource.close();
        return;
      }

      onMessage?.(data);

      if (data.isComplete) {
        onComplete?.();
        eventSource.close();
      }
    } catch (error) {
      onError?.(error);
      eventSource.close();
    }
  };

  eventSource.onerror = (error) => {
    onError?.(error);
    eventSource.close();
  };

  return () => {
    eventSource.close();
  };
};

export const getUnitDataStream = ({
  params,
  onMessage,
  onError,
  onComplete,
}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value != null)
  );

  const eventSource = new EventSource(
    `${BASE_URL}${stream_url}/unit-data-stream?${new URLSearchParams(
      cleanParams
    ).toString()}`
  );

  eventSource.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      if (data.error) {
        onError?.(data.error);
        eventSource.close();
        return;
      }

      onMessage?.(data);

      if (data.isComplete) {
        onComplete?.();
        eventSource.close();
      }
    } catch (error) {
      onError?.(error);
      eventSource.close();
    }
  };

  eventSource.onerror = (error) => {
    onError?.(error);
    eventSource.close();
  };

  return () => {
    eventSource.close();
  };
};

export const getUnitCountStream = ({
  params,
  onMessage,
  onError,
  onComplete,
}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value != null)
  );

  const eventSource = new EventSource(
    `${BASE_URL}${stream_url}/unit-count?${new URLSearchParams(
      cleanParams
    ).toString()}`
  );

  eventSource.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);

      if (data.error) {
        onError?.(data.error);
        eventSource.close();
        return;
      }

      onMessage?.(data);

      if (data.isComplete) {
        onComplete?.();
        eventSource.close();
      }
    } catch (err) {
      onError?.(err);
      eventSource.close();
    }
  };

  eventSource.addEventListener("done", () => {
    onComplete?.();
    eventSource.close();
  });

  eventSource.onerror = (error) => {
    onError?.(error);
    eventSource.close();
  };

  return () => {
    eventSource.close();
  };
};

export const getCSVData = async ({ start_date, end_date, fields }) => {
  try {
    const response = await client.post(
      `/csv-data`,
      {
        start_date,
        end_date,
        fields,
      },
      {
        headers: { "Content-Type": "application/json" },
        responseType: "blob",
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
